import { Suspense } from "react";
import { getPublicMenuLayout } from "./public-menu/layoutRegistry";
import { PublicMenuLoadingScreen } from "./public-menu/shared/PublicMenuLoadingScreen";
import { usePublicMenuController } from "./public-menu/usePublicMenuController";

export default function PublicMenuPage() {
  const controller = usePublicMenuController();
  const Layout = getPublicMenuLayout(controller.tenant?.theme.layoutId);
  return <Suspense fallback={<PublicMenuLoadingScreen />}><Layout controller={controller} /></Suspense>;
}
